import {useNavigate} from "react-router-dom";
import {useContext} from "react";
import {ChangesContext, ToastContext} from "../Contexts";
import {
    FilterBaseRequest, Section, SectionFilterRequest, SectionFilterResponse,
    ToastFailureMessage,
    ToastSuccessMessage, UpdateSectionRequest
} from "../Models/Models";
import HttpRepository from "./HttpRepository";

export function SectionService() {
    const navigate = useNavigate()
    let {setToast}: any = useContext(ToastContext);
    let { setHasChanges } : any = useContext(ChangesContext);

    async function getSection(id: number): Promise<Section> {
        try {
            return (await HttpRepository.getSection(id)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function filterSections(request: SectionFilterRequest): Promise<SectionFilterResponse> {
        try {
            return (await HttpRepository.filterSection(request)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function updateSection(request: UpdateSectionRequest): Promise<void> {
        try {
            await HttpRepository.updateSection(request);
            setHasChanges(true);
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotSaved});
            return;
        }

        setToast({message: ToastSuccessMessage.dataSaved});
        navigate("/section/table");
    }

    return {getSection, filterSections, updateSection}
}